import { hasApiMenuPermission } from '@/libs/permissions';

// 通过 computed 计算属性，获取权限
// 当前模块使用过的权限，全部集中在这里，方便查看和维护
export default {
  computed: {
    // 权限 - 应用
    AUTH_APPLICATION() {
      return hasApiMenuPermission('and', ['auth_application']);
    },

    // 权限 - 应用 - 列表
    AUTH_APPLICATION_LIST() {
      return hasApiMenuPermission('and', ['auth_application', 'auth_application_list']);
    },

    // 权限 - 应用 - 添加
    AUTH_APPLICATION_ADD() {
      return hasApiMenuPermission('and', ['auth_application', 'auth_application_add']);
    },

    // 权限 - 应用 - 编辑
    AUTH_APPLICATION_EDIT() {
      return hasApiMenuPermission('and', ['auth_application', 'auth_application_edit']);
    },

    // 权限 - 应用 - 详情
    AUTH_APPLICATION_DETAIL() {
      return hasApiMenuPermission('and', ['auth_application', 'auth_application_detail']);
    },

    // 权限 - 应用 - 删除
    AUTH_APPLICATION_DELETE() {
      return hasApiMenuPermission('and', ['auth_application', 'auth_application_del']);
    },

    // 权限 - 应用 - 启用/禁用
    AUTH_APPLICATION_ENABLE_DISABLE() {
      return hasApiMenuPermission('and', ['auth_application', 'auth_application_enable_disable']);
    },

    // 权限 - 应用 - 获取密钥
    AUTH_APPLICATION_GET_SECRECT() {
      return hasApiMenuPermission('and', ['auth_application', 'auth_application_get_app_secrect']);
    },
  },
};
